import React from 'react'
import AboutHuntToken from './AboutHuntToken'
import HuntTokenDetails from './HuntTokenDetails'
import HuntTokenExtraDetails from './HuntTokenExtraDetails'

function Overview() {
  return (
    <>
      <AboutHuntToken />
      <HuntTokenDetails />
      <HuntTokenExtraDetails />
    </>
  )
}

export default Overview
